module.exports = __webpack_public_path__ + "img/b1.0eb63eb.png";